const CONFIGURACAO_HORARIO_MEDICO_URL = `${process.env.REACT_APP_URL_API}/api/configuracao-horario-medico`;

const getHeaders = (token) => ({
    "Content-Type": "application/json",
    Authorization: token,
});

const tratarResposta = async (response) => {
    if (response.ok) {
        if (response.status === 204) {
            return null;
        }

        return await response.json();
    }

    const mensagemErro = await response.text();
    throw new Error(mensagemErro || "Erro ao salvar configuracao de horario.");
};

export const getConfiguracoesHorarioMedicoPorUsuario = async (
    token,
    usuarioId,
) => {
    const response = await fetch(
        `${CONFIGURACAO_HORARIO_MEDICO_URL}/usuario/${usuarioId}`,
        {
            method: "GET",
            headers: getHeaders(token),
        },
    );

    return await tratarResposta(response);
};

export const getDiasExtrasAtendimentoMedicoPorUsuario = async (
    token,
    usuarioId,
) => {
    const response = await fetch(
        `${CONFIGURACAO_HORARIO_MEDICO_URL}/usuario/${usuarioId}/dias-extras`,
        {
            method: "GET",
            headers: getHeaders(token),
        },
    );

    return await tratarResposta(response);
};

export const getDiasBloqueadosAtendimentoMedicoPorUsuario = async (
    token,
    usuarioId,
) => {
    const response = await fetch(
        `${CONFIGURACAO_HORARIO_MEDICO_URL}/usuario/${usuarioId}/dias-bloqueados`,
        {
            method: "GET",
            headers: getHeaders(token),
        },
    );

    return await tratarResposta(response);
};

export const getConfiguracoesAtendimentoMedicoPorUsuario = async (
    token,
    usuarioId,
) => {
    const [horariosFixos, diasExtras, diasBloqueados] = await Promise.all([
        getConfiguracoesHorarioMedicoPorUsuario(token, usuarioId),
        getDiasExtrasAtendimentoMedicoPorUsuario(token, usuarioId),
        getDiasBloqueadosAtendimentoMedicoPorUsuario(token, usuarioId),
    ]);

    return [
        ...(Array.isArray(horariosFixos) ? horariosFixos : []),
        ...(Array.isArray(diasExtras)
            ? diasExtras.map((diaExtra) => ({
                  ...diaExtra,
                  tipoConfiguracao: "DIA_EXTRA",
              }))
            : []),
        ...(Array.isArray(diasBloqueados)
            ? diasBloqueados.map((diaBloqueado) => ({
                  ...diaBloqueado,
                  tipoConfiguracao: "BLOQUEIO",
              }))
            : []),
    ];
};

export const criarConfiguracaoHorarioMedico = async (token, payload) => {
    const response = await fetch(CONFIGURACAO_HORARIO_MEDICO_URL, {
        method: "POST",
        headers: getHeaders(token),
        body: JSON.stringify(payload),
    });

    return await tratarResposta(response);
};

export const criarDiaExtraAtendimentoMedico = async (token, payload) => {
    const response = await fetch(
        `${CONFIGURACAO_HORARIO_MEDICO_URL}/dias-extras`,
        {
            method: "POST",
            headers: getHeaders(token),
            body: JSON.stringify(payload),
        },
    );

    return await tratarResposta(response);
};

export const atualizarDiaExtraAtendimentoMedico = async (
    token,
    id,
    payload,
) => {
    const response = await fetch(
        `${CONFIGURACAO_HORARIO_MEDICO_URL}/dias-extras/${id}`,
        {
            method: "PUT",
            headers: getHeaders(token),
            body: JSON.stringify(payload),
        },
    );

    return await tratarResposta(response);
};

export const excluirDiaExtraAtendimentoMedico = async (token, id) => {
    const response = await fetch(
        `${CONFIGURACAO_HORARIO_MEDICO_URL}/dias-extras/${id}`,
        {
            method: "DELETE",
            headers: getHeaders(token),
        },
    );

    return await tratarResposta(response);
};

export const criarDiaBloqueadoAtendimentoMedico = async (token, payload) => {
    const response = await fetch(
        `${CONFIGURACAO_HORARIO_MEDICO_URL}/dias-bloqueados`,
        {
            method: "POST",
            headers: getHeaders(token),
            body: JSON.stringify(payload),
        },
    );

    return await tratarResposta(response);
};

export const excluirDiaBloqueadoAtendimentoMedico = async (token, id) => {
    const response = await fetch(
        `${CONFIGURACAO_HORARIO_MEDICO_URL}/dias-bloqueados/${id}`,
        {
            method: "DELETE",
            headers: getHeaders(token),
        },
    );

    return await tratarResposta(response);
};

export const atualizarConfiguracaoHorarioMedico = async (
    token,
    id,
    payload,
) => {
    const response = await fetch(`${CONFIGURACAO_HORARIO_MEDICO_URL}/${id}`, {
        method: "PUT",
        headers: getHeaders(token),
        body: JSON.stringify(payload),
    });

    return await tratarResposta(response);
};

export const excluirConfiguracaoHorarioMedico = async (token, id) => {
    const response = await fetch(`${CONFIGURACAO_HORARIO_MEDICO_URL}/${id}`, {
        method: "DELETE",
        headers: getHeaders(token),
    });

    return await tratarResposta(response);
};
